import * as LogRocket from 'logrocket';

/**
 * Interface/types for logrocket metadata
 */
type View =
  | 'checkout'
  | 'checkout-confirmation'
  | 'confirmed-number'
  | 'error'
  | 'home'
  | 'selectemail'
  | 'selectclio'
  | 'get-number'
  | 'request-access'
  | 'verifyemail';

/**
 * Formats a phone number
 * @param a phone number
 * @return (###) ###-####
 */
export function formatNumber(phoneNumber: string): string {
  const unformattedNum = phoneNumber;
  const cleaned = ('' + unformattedNum).replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return phoneNumber;
}
/**
 * Formats province/state city string
 * @param province/state|city
 * @return province/state, city
 */
export function formatLocation(location: string): string {
  try {
    return location.replace('|', ', ');
  } catch {
    return location;
  }
}

/**
 * Captures errors into console.error in development and LogRocket console in production
 */
export function logErrors(error: any, triggerFunction: string, view: View) {
  // Should be typed to ICaptureOptions but this is not exported from the LogRocket node_module
  // TODO: Ask Alex re best practice for a type that isn't exported
  const logRocketMetaData: any = {
    tags: {
      triggerFunction,
      view,
    },
  };

  if (process.env.NODE_ENV === 'production') {
    LogRocket.captureException(error, logRocketMetaData);
  } else {
    console.error(`${view} > ${triggerFunction}:`);
    console.error(error);
  }
}

export function passwordRegExTest(password: string) {
  // tslint:disable-next-line:max-line-length
  const passwordRegEx: RegExp = /^((?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])|(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])|(?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Z])).{8,}/;
  return passwordRegEx.test(password);
}
export function emailRegExTest(email: string) {
  // tslint:disable-next-line:max-line-length
  const emailRegEx: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegEx.test(email);
}
